import { useMemo } from 'react'
import { ALL_FIELD_TYPES } from '@carto/kepler.gl/constants'
import { AggregationTypes } from '@carto/react-core'
import { HistogramWidget, MapDatasetEnriched } from 'features/builder'
import { KeplerFieldType } from 'features/builder/types'

const availableFieldTypesForColumn: KeplerFieldType[] = [ALL_FIELD_TYPES.integer, ALL_FIELD_TYPES.real]

export function isHistogramWidgetValid(widget: HistogramWidget, { source }: { source: MapDatasetEnriched }): boolean {
  const columnType = source.fields?.find((f) => f.id === widget.column)?.type as KeplerFieldType

  return Boolean(widget.column && columnType && availableFieldTypesForColumn.includes(columnType))
}

function useWidgetHistogramModel({ source }) {
  const validateWidget = (widget: HistogramWidget) => {
    const columnType = source.fields.find((f) => f.id === widget.column)?.type

    if (!availableFieldTypesForColumn.includes(columnType)) {
      widget.column = ''
      widget.spatialIndexAggregation = undefined
    }

    widget.operation = AggregationTypes.COUNT

    if (!widget.column) {
      widget.isValid = false
    } else {
      widget.isValid = true
    }
  }

  const isWidgetAvailable = useMemo(() => {
    return source.fields.some((f) => availableFieldTypesForColumn.includes(f.type))
  }, [source])

  const availableOperations = useMemo(() => {
    if (!source.fields.some((f) => availableFieldTypesForColumn.includes(f.type))) {
      return []
    }
    return [AggregationTypes.COUNT]
  }, [source])

  return {
    validateWidget,
    isWidgetAvailable,
    availableFieldTypesForColumn,
    availableOperations
  }
}

export default useWidgetHistogramModel
